import { createSlice } from "@reduxjs/toolkit"
import { EXISTING_FIELDS, NEW_FIELDS } from "../constant/configurationConstant"
import { MANUAL_FIELD } from "../constant/Stepper"
import {
  changeCurrencyToNumber,
  formatNumberWithCommas,
  getOptionList,
} from "../components/utils/helpers"

const initialState: any = {
  formArray: [],
  isValidForm: false,
  isSubmitted: false,
  hasUpdatedForm: false,
  currencySign:"$",
  currencyValue:1,
  currencyIds:1,
  currencyError:false
}
const formReducer = createSlice({
  name: "formReducer",
  initialState,
  reducers: {
    handleFormValues: (state, action) => {
      state.formArray = action.payload
    },
    handleUpdateCurrencySign:(state,action)=>{
      state.currencySign = action.payload
    },
    handleUpdateCurrencyValue:(state,action)=>{
      state.currencyValue  = action.payload
    },
    modifyFormValues: (state, action) => {

      const { name, value, fieldName, hasEditable,CurrencyListOption } = action.payload
      const currencytonumber = changeCurrencyToNumber(value)

      const numericValue =
        isNaN(currencytonumber) || value == "" ? value : currencytonumber // Convert formatted value to number

      let hasValidForm = true
      const formstate = [...JSON.parse(JSON.stringify(state.formArray))]
      for (const index in formstate) {
        const inputField = formstate[index]
        const hasManualField = name?.includes(MANUAL_FIELD.name)
        const inputName = hasManualField
          ? name?.split(MANUAL_FIELD.name)[0]
          : name

        if (inputField.name === inputName && !name.includes("-ext")) {
          // Handle manual input fields if present
          if (hasManualField) {
            const { validation } = inputField?.manualInputFields[0] ?? {}
            const { min, max, minValue } = validation || {} // Get min and max from validation
            // Convert min and max to numbers for comparison
            const numericMin = changeCurrencyToNumber(min)
            const numericMax = changeCurrencyToNumber(max)

            formstate[index].manualInputFields[0].value = value
            const isInRange =
              (numericMin ? numericValue >= numericMin : true) &&
              (numericMax ? numericValue <= numericMax : true)

            if ((min || max) && numericValue) {
              if (numericValue < numericMin) {
                inputField.manualInputFields[0].isValid = false
                inputField.manualInputFields[0].error = `Value can't be less than ${numericMin}`
              } else if (numericValue > numericMax) {
                inputField.manualInputFields[0].isValid = false
                inputField.manualInputFields[0].error = `Value can't be more than ${numericMax}`
              } else {
                inputField.manualInputFields[0].error = "" // Clear error if valid
                inputField.manualInputFields[0].isValid =
                  numericValue === MANUAL_FIELD.id
                    ? false
                    : String(numericValue)?.length > 0 && isInRange
              }
            } else {
              inputField.manualInputFields[0].error = "" // Clear error if valid
              inputField.manualInputFields[0].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0 && isInRange
            }
            if (minValue) {
              if (numericValue < minValue) {
                inputField.manualInputFields[0].isValid = false
                inputField.manualInputFields[0].error = ` enter value more than 0`
              }
            }
            formstate[index].isValid =
              numericValue === MANUAL_FIELD.id
                ? false
                : String(numericValue)?.length > 0
          } else {
            const { validation } = inputField

            const { min, max, pattern } = validation || {} // Get min and max from validation
            // if (minValue) {
            //   if (numericValue < minValue) {
            //     inputField.isValid = false
            //     inputField.error = ` enter value more than 0`
            //   }}
          
         
            if ((min || max) && value < min && value) {
              inputField.isValid = false
              inputField.error =
                value < min
                  ? `Value can't be less than ${min}`
                  : `Value can't be more than ${max}` 
            } else if (pattern && !new RegExp(pattern).test(value) && value) {
              inputField.isValid = false
              inputField.error = `Value does not match the required pattern`
            } else {
              inputField.error = "" 
              state.currencyError=false
              if (inputField.name === "currencyValue") {
                if (numericValue < 0.1) {
                  state.isValidForm = false; 
                  inputField.isValid = false;  
                  inputField.error = "Value must be at least 0.1"; 
                  state.currencyError = true; 
                } else {
                  inputField.isValid = true;  
                  inputField.error = ""; 
                }
              }
              if(formstate[index].name == "currencyId"){
               const filteredCurrency = CurrencyListOption.filter((currency:any) => currency.id== parseInt(value) );
               state.currencySign = filteredCurrency[0].sign
               state.currencyValue = filteredCurrency[0].value
               if(filteredCurrency[0].id !==undefined) {
                state.currencyIds = filteredCurrency[0].id
               }
               const formFilter = formstate.filter((currency:any) => currency.id== "currencyValue" );
              if (formFilter.length > 0 && filteredCurrency.length > 0) {
                formFilter[0].value = formatNumberWithCommas(filteredCurrency[0].value )
                 }
              }
              if(formstate[index].name == "currencyValue"){
                formstate[index].value = value
                state.currencyValue = value
              }
              formstate[index].value = value
              formstate[index].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0
            }

            if (formstate[index]?.manualInputFields?.length > 0)
              formstate[index].manualInputFields[0].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0
          }

          if (fieldName) formstate[index].fieldName = fieldName
        }

        // For existing estimate fields and if already ext field is updating then checking
        const existingFieldName = inputName.includes("-ext")
          ? inputName
          : `${inputName}-ext`
        if (inputField.name === existingFieldName) {
          // // update existing field if edit wil be false and value will be empty
          if (hasEditable && !name.includes("-ext")) {
            continue
          }

          // Handle manual input fields if present
          if (hasManualField) {
            const { validation } = inputField?.manualInputFields[0] ?? {}

            const { min, max } = validation || {} // Get min and max from validation
            // Convert min and max to numbers for comparison
            const numericMin = changeCurrencyToNumber(min)
            const numericMax = changeCurrencyToNumber(max)
            formstate[index].manualInputFields[0].value = value
            const isInRange =
              (numericMin ? numericValue >= numericMin : true) &&
              (numericMax ? numericValue <= numericMax : true)
            if (
              (min || max) &&
              (numericValue < numericMin || numericValue > numericMax) &&
              numericValue
            ) {
              inputField.manualInputFields[0].isValid = false
              inputField.manualInputFields[0].error =
                numericValue < numericMin
                  ? `Value can't be less than ${numericMin}`
                  : `Value can't be more than ${numericMax}` // Adjust this message as needed
            } else {
              inputField.manualInputFields[0].error = "" // Clear error if valid
              inputField.manualInputFields[0].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0 && isInRange
            }
            formstate[index].isValid =
              numericValue === MANUAL_FIELD.id
                ? false
                : String(numericValue)?.length > 0
          } else {
            state.currencyError=false
              if (inputField.name === "currencyValue") {
                if (numericValue < 0.1) {
                  state.isValidForm = false;  // Set overall form validity to false
                  inputField.isValid = false;  // Mark this specific field as invalid
                  inputField.error = "Value must be at least 0.1";  // Show error message
                  state.currencyError = true;  // Set currency error flag to true
                } else {
                  inputField.isValid = true;  // Mark the field as valid
                  inputField.error = "";  // Clear the error message
                }
              }
            formstate[index].value = value
            formstate[index].isValid =
              numericValue === MANUAL_FIELD.id
                ? false
                : String(numericValue)?.length > 0
            if (formstate[index]?.manualInputFields?.length > 0)
              formstate[index].manualInputFields[0].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0
          }
        }

        // Check if any field is invalid and set the overall form validity
        if (!formstate[index].isValid) {
          hasValidForm = false
        }
        if (
          formstate[index]?.manualInputFields &&
          "isValid" in formstate[index].manualInputFields[0] &&
          !formstate[index].manualInputFields[0].isValid
        ) {
          hasValidForm = false
        }
        //  (fieldName) formstate[index].fieldName = fieldName;
        formstate[index] = inputField
      }

      state.isValidForm = hasValidForm
      state.isSubmitted = false
      state.hasUpdatedForm = true
      state.formArray = formstate
    },
    handleUpdateEstimateDetail: (state, action) => {
      let hasValidForm = true

      const estimateInfo = action.payload

      for (const input of state.formArray) {
        const key = input?.name?.includes("-ext") ? EXISTING_FIELDS : NEW_FIELDS
        const inputName = input?.name?.includes("-ext")
          ? input.name.split("-ext")[0]
          : input.name

        if (estimateInfo[key][inputName]) {
          input.value = estimateInfo[key][inputName]
          input.isValid = Boolean(input.value)
        }
         if(estimateInfo && estimateInfo?.estimateNew?.currencyDetails?.currencyDetails.sign){
          state.currencySign=estimateInfo?.estimateNew?.currencyDetails?.currencyDetails.sign
         }
        if (!input.isValid) {
          hasValidForm = false
        }
      }

      state.isValidForm = hasValidForm
    },
    updateSubmittedForm: (state, action) => {
      state.isSubmitted = action.payload
    },
    updatedIsValidForm: (state, action) => {
      state.isValidForm = action.payload
    },
    updatedIsModifyForm: (state, action) => {
      state.hasUpdatedForm = action.payload
    },
    updateExistingValues: (state, action) => {
      const { name, hasEditable } = action.payload
      const formstate = [...JSON.parse(JSON.stringify(state.formArray))]

      let hasValidForm = true
      for (const index in formstate) {
        const inputField = formstate[index]

        const hasManualField = name?.includes(MANUAL_FIELD.name)
        const inputName = hasManualField
          ? name?.split(MANUAL_FIELD.name)[0]
          : name

        // For existing estimate fields and if already ext field is updating then checking
        const existingFieldName = inputName.includes("-ext")
          ? inputName
          : `${inputName}-ext`
        if (inputField.name === existingFieldName) {
          const formInputField =
            formstate.find((elm: any) => elm.name === name) ?? ""

          const currencytonumber = changeCurrencyToNumber(formInputField.value)

          const numericValue =
            isNaN(currencytonumber) || formInputField?.value == ""
              ? formInputField?.value
              : currencytonumber // Convert formatted value to number

          // Handle manual input fields if present
          if (hasManualField) {
            const { validation } = inputField?.manualInputFields[0] ?? {}

            // update existing field if edit wil be false and value will be empty
            if (hasEditable && inputField?.manualInputFields[0]?.value) {
              continue
            }

            const { min, max } = validation || {} // Get min and max from validation
            // Convert min and max to numbers for comparison
            const numericMin = changeCurrencyToNumber(min)
            const numericMax = changeCurrencyToNumber(max)
            formstate[index].manualInputFields[0].value = formInputField?.value
            const isInRange =
              (numericMin ? numericValue >= numericMin : true) &&
              (numericMax ? numericValue <= numericMax : true)
            if (
              (min || max) &&
              (numericValue < numericMin || numericValue > numericMax) &&
              numericValue
            ) {
              inputField.manualInputFields[0].isValid = false
              inputField.manualInputFields[0].error =
                numericValue < numericMin
                  ? `Value can't be less than ${numericMin}`
                  : `Value can't be more than ${numericMax}` // Adjust this message as needed
            } else {
              inputField.manualInputFields[0].error = "" // Clear error if valid
              inputField.manualInputFields[0].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0 && isInRange
            }
            formstate[index].isValid =
              numericValue === MANUAL_FIELD.id
                ? false
                : String(numericValue)?.length > 0
          } else {
            // update existing field if edit wil be false and value will be empty
            if (hasEditable && inputField?.value) {
              continue
            }
            formstate[index].value = formInputField?.value
            formstate[index].isValid =
              numericValue === MANUAL_FIELD.id
                ? false
                : String(numericValue)?.length > 0
            if (formstate[index]?.manualInputFields?.length > 0)
              formstate[index].manualInputFields[0].isValid =
                numericValue === MANUAL_FIELD.id
                  ? false
                  : String(numericValue)?.length > 0
          }
        }

        // Check if any field is invalid and set the overall form validity
        if (!formstate[index].isValid) {
          hasValidForm = false
        }
        if (
          formstate[index]?.manualInputFields &&
          "isValid" in formstate[index].manualInputFields[0] &&
          !formstate[index].manualInputFields[0].isValid
        ) {
          hasValidForm = false
        }
        //  (fieldName) formstate[index].fieldName = fieldName;
        formstate[index] = inputField
      }

      state.isValidForm = hasValidForm
      state.isSubmitted = false
      state.hasUpdatedForm = true
      state.formArray = formstate
    },
    // Set selected assumption value in form array
    updatedSelectedAssumption: (state, action) => {
      const { selectedAssumption, value, configData } = action.payload
      let hasValidForm = true

      for (const index in state.formArray) {
        if (state.formArray[index].assumptionId === selectedAssumption) {
          if (!isNaN(value)) {
            if (state.formArray[index].hasExcludeOption && value <= -1) {
              state.formArray[index].value = value
            } else {
              const optionList = getOptionList(
                configData,
                state.formArray[index]
              )
              state.formArray[index].value = optionList.length
                ? optionList.find((option: any) => +option.valueType === +value)
                    ?.id
                : ""
            }
            state.formArray[index].isValid = true
            state.formArray[index].manualInputFields[0].isValid = true
          } else {
            state.formArray[index].value = value
            state.formArray[index].isValid = false
            state.formArray[index].manualInputFields[0].isValid = false
          }
        }

        // Check if any field is invalid and set the overall form validity
        if (!state.formArray[index].isValid) {
          hasValidForm = false
        }
        if (
          state.formArray[index]?.manualInputFields &&
          "isValid" in state.formArray[index].manualInputFields[0] &&
          !state.formArray[index].manualInputFields[0].isValid
        ) {
          hasValidForm = false
        }
      }

      state.isValidForm = hasValidForm
      state.hasUpdatedForm = true
    },
    handleResetFormReducer: (state) => {
      state = {
        formArray: [],
        isValidForm: false,
        isSubmitted: false,
        hasUpdatedForm: false,
      }
      return state
    },
  },
  extraReducers: () => {},
})

export const {
  handleFormValues,
  modifyFormValues,
  updateSubmittedForm,
  updatedIsValidForm,
  handleUpdateEstimateDetail,
  updatedIsModifyForm,
  updatedSelectedAssumption,
  handleResetFormReducer,
  updateExistingValues,
  handleUpdateCurrencySign,
  handleUpdateCurrencyValue
} = formReducer.actions

export default formReducer.reducer
